<template>

  <section id="call-to-action" class="uk-padding-large uk-padding-remove-left uk-padding-remove-right"
           v-if="call_to_action.list"
  >
    <div v-for="s in call_to_action.list" v-bind:key="s.id">
      <div class="uk-container uk-container-large" >
        <div class="uk-flex uk-flex-column">
          <h2 class="uk-h2 uk-align-center uk-width-2-3@l">{{s.headline}}</h2>
          <div class="uk-align-center uk-width-2-3@l" v-html="s.body_text"></div>
          <div class="button-container uk-container" v-if="s.button_text_one">
            <a href="#explanation-organs" v-on:click.prevent="scrollTo('#explanation-organs')" class="uk-button uk-button-default uk-button-large uk-text-large">
              {{s.button_text_one}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
import {CALL_TO_ACTION} from '../../constants/graphql'
import UIkit from 'uikit'
import Icons from 'uikit/dist/js/uikit-icons'
import {Power2, TweenLite} from 'gsap'
// eslint-disable-next-line
import ScrollToPlugin from 'gsap/ScrollToPlugin'

UIkit.use(Icons)

export default {
  name: 'CallToAction',
  data () {
    return {
      call_to_action: {},
      parent_path: 'has_parent=/website/home-spenden/'
    }
  },
  apollo: {
    call_to_action: {
      query: CALL_TO_ACTION,
      variables () {
        return {
          parentPath: this.parent_path
        }
      }
    }
  },
  methods: {
    showModal () {
      this.$modal.show('gift-sponsorship')
    },
    hideModal () {
      this.$modal.hide('gift-sponsorship')
    },
    scrollTo (id) {
      TweenLite.to(window, 2.4, {
        scrollTo: id,
        ease: Power2.easeOut
      })
    }
  }
}
</script>

<style lang="scss">
  @import "~uikit/src/scss/variables-theme";
  @import "../../assets/scss/variables";
  @import "../../assets/scss/mixins";

  html.csshyphens {
    #call-to-action {
      p {
        hyphens: auto;
        @media (min-width: $breakpoint-medium) {
          hyphens: unset;
        }
      }
    }
  }

  #call-to-action {
    p, li {
      @include fontSize(18px);
      @media (min-width: $breakpoint-medium) {
        @include fontSize(21px);
      }
    }
    h3 {
      @include fontSize(35px);
    }
    .v--modal {
      h3 {
        @include fontSize(29px);
        hyphens: auto;
        @media (min-width: $breakpoint-medium) {
          hyphens: none;
          @include fontSize(35px);
        }
      }
      .uk-button {
        line-height: 1.3;
        padding-top: calculateRem(4px);
        padding-bottom: calculateRem(4px);
        @media (min-width: $breakpoint-medium) {
          line-height: initial;
          padding: calculateRem(8px) calculateRem(100px);
        }
      }
    }

    [data-uk-grid] {
      & > div {
        padding-bottom: 2em;
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HomePage/CallToAction.vue